export default __webpack_public_path__ + "static/media/ganger_21.e152d471.png";